import { createAction } from '@reduxjs/toolkit';
import type { AppThunk } from '../store/configureStore';

export const SHOW_LOADING_SPINNER = createAction<string>('SHOW_LOADING_SPINNER');
export const HIDE_LOADING_SPINNER = createAction<string>('HIDE_LOADING_SPINNER');

export const showLoadingSpinner =
  (message = ''): AppThunk =>
  (dispatch) =>
    dispatch(SHOW_LOADING_SPINNER(message));

export const hideLoadingSpinner =
  (message = ''): AppThunk =>
  (dispatch) =>
    dispatch(HIDE_LOADING_SPINNER(message));
